$(document).ready(function() {
  

$('#axeUpsellCheckbox').change(function(){

  if($(this).is(':checked'))
  $('.block-swatch input')[1].click();
else   $('.block-swatch input')[0].click();
                               })

                  })